import React from 'react';

export const LongArrowIcon = () => {
  return (
    <svg width="27" height="15" viewBox="0 0 27 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.3136 7.6131C23.1039 8.72258 20.5966 10.5209 18.792 13.0081H17.4191C18.0379 11.2646 19.0756 9.61864 20.5322 8.07025H1.25439V6.27802H20.5322C19.0756 4.72964 18.0379 3.07762 17.4191 1.32196H18.792C20.5966 3.80914 23.1039 5.60752 26.3136 6.71698V7.6131Z"
        fill="#F6AE11"
      />
    </svg>
  );
};
